__webpack_require__.p = "https://static.flicknovelcdn.com/reader-website-static/prod_4830894_75_1248f886/_next/";